import { Directive } from '@angular/core';
import { NG_VALIDATORS, FormControl, Validator, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[stagionalita-validator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: StagionalitaValidatorDirective, multi: true }]
})
export class StagionalitaValidatorDirective {

  validate(c: FormControl): ValidationErrors {
    console.log('stagionalita-validator', c.value);
    const isValid = c.value && c.value.value;
    const message = {
      'stagionalita': {
        'message': 'Specificare una stagionalità'
      }
    };
    return isValid ? null : message;
  }

}



// WEBPACK FOOTER //
// ./src/app/helpers/validators/stagionalita-validator.directive.ts